import { createAction, createReducer } from "@reduxjs/toolkit";

const dataProfileWishesSet = createAction<any>("dataProfileWishesSet");

const dataProfilePrfsSet = createAction<any | any[]>("dataProfilePrfsSet");

const dataProfileWishes = createReducer([], (builder) => {
  builder.addCase(dataProfileWishesSet, (state, action) => action.payload);
});

type PayloadType = {
  newData: any[];
  paginatedData: any[];
};

const dataProfilePrfs = createReducer([], (builder: any) => {
  builder.addCase(
    dataProfilePrfsSet,
    (state: any[], action: { payload: PayloadType }) => {
      console.log("++++++++++++++++++++ state", state);
      console.log("++++++++++++++++++++ action", action);

      if (
        action.payload &&
        action.payload.newData &&
        action.payload.newData.length > 0
      ) {
        return action.payload.newData;
      }

      if (
        action.payload &&
        action.payload.paginatedData &&
        action.payload.paginatedData.length > 0
      ) {
        return [...state, ...action.payload.paginatedData];
      }

      return [];
    }
  );
});

//
export const actionProfile = {
  dataProfileWishesSet,
  dataProfilePrfsSet,
  // dataProfilePrfsAppend,
};

export const reducerProfile = {
  dataProfileWishes,
  dataProfilePrfs,
  // dataProfilePrfsAppendReduser,
};
